var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "fill-height dark" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "7" } },
            [
              _c("v-img", {
                attrs: {
                  "max-width": "150",
                  src: require("@/assets/logo_stf_transparent_black.png"),
                },
              }),
              _c(
                "h1",
                {
                  staticClass: "text-h1 my-4 font-weight-bold",
                  staticStyle: { "font-size": "2.4em" },
                },
                [_vm._v("SEO Team Flow")]
              ),
              _c("h2", { staticClass: "text-h2 mt-4 font-weight-bold mb-12" }, [
                _vm._v("SEO that flows"),
              ]),
              _c(
                "v-container",
                { staticStyle: { position: "absolute", top: "65vh" } },
                [
                  _c(
                    "a",
                    { attrs: { href: "/signup" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "text-yellow text-uppercase my-4",
                          attrs: { size: "x-large", variant: "outlined" },
                          on: { click: _vm.navigateToSignup },
                        },
                        [_vm._v(" Try for free ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "my-4",
                      staticStyle: { "font-size": "1.5em" },
                    },
                    [
                      _vm._v("Have an Account? "),
                      _c("a", { attrs: { href: "#" } }, [_vm._v("Log in")]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "5" } },
            [
              _c("v-img", {
                attrs: {
                  width: "100%",
                  "max-width": "700",
                  src: require("@/assets/splash.png"),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }